import SerialNumberSearch from 'components/Search/SerialNumberSearch'

import createWrappedField from './createWrappedField'

export default createWrappedField({
  Component: SerialNumberSearch,
  name: 'DDISerialNumberSearch'
})
